import { useState } from "react"
import { statsData, patientsData, Patient } from "../-data/fixtures"
import { StatsCards } from "./stats-cards"
import { PatientsTable } from "./patients-table"

export default function PatientsPage() {
  const [patients, setPatients] = useState<Patient[]>(patientsData)

  const handleAddPatient = (newPatient: Patient) => {
    setPatients([...patients, newPatient])
  }

  return (
    <div className="flex flex-col h-full p-6 bg-white overflow-y-auto">
      <StatsCards stats={statsData} />
      <PatientsTable patients={patients} onAddPatient={handleAddPatient} />
    </div>
  )
}
